<template>
  <div>
    <v-row>
      <v-col cols="12">
        <ReportsFilters @filter="filterBy" :loading="loading" />
      </v-col>
      <v-col cols="12">
        <v-row>
          <v-col
            cols="12"
            lg="auto"
            class="text-start"
            style="display: flex; align-items: center"
          >
            <span class="textLight--text font-weight-medium text-h5">
              {{ $t("reports.registrationReport") }}
            </span>
          </v-col>
          <v-spacer></v-spacer>
          <v-col cols="12" lg="auto">
            <reports-sub-filters
              @exportToExcel="exportToXL"
              @filter="filterBy"
              :exportBtnLoading="exporting"
              :disable="disableSubFilters"
            />
          </v-col>
        </v-row>
      </v-col>

      <v-col cols="12" v-if="$vuetify.breakpoint.mdAndUp">
        <v-card
          flat
          class="rounded-lg primary--text"
          :style="$vuetify.breakpoint.md ? 'font-size: 14px !important;' : ''"
        >
          <v-row align="center">
            <v-col cols class="text-start">
              <div class="ps-3">
                {{ $t("user.registration.name") }}
              </div>
            </v-col>
            <v-col cols class="text-start">
              {{ $t("user.registration.training") }}
            </v-col>
            <v-col cols class="text-start">
              {{ $t("course.trainer") }}
            </v-col>
            <v-col cols class="text-start">
              {{ $t("user.registration.organization") }}
            </v-col>
            <v-col cols="auto">
              <div style="width: 110px">
                {{ $t("user.registration.registrationStatus") }}
              </div>
            </v-col>
            <v-col cols="auto">
              <div style="width: 80px">
                {{ $t("user.registration.employeeId") }}
              </div>
            </v-col>
            <v-col cols="auto">
              <div style="width: 110px">
                {{ $t("user.registration.startDate") }}
              </div>
            </v-col>
            <v-col cols="auto">
              <div style="width: 110px">
                {{ $t("reports.certificateExpiryDate") }}
              </div>
            </v-col>
          </v-row>
        </v-card>
      </v-col>

      <v-col cols="12">
        <v-row v-if="loading">
          <v-col cols="12">
            <v-progress-circular
              indeterminate
              color="primary"
            ></v-progress-circular>
          </v-col>
        </v-row>
        <v-row v-else-if="datas.length">
          <v-col cols="12" v-for="(data, index) in datas" :key="index">
            <registration-report-card :registrationData="data" />
          </v-col>
        </v-row>
        <v-row
          v-else
          class="textLight--text font-weight-medium"
          align="center"
        >
          <v-col cols="12">
            {{ $t("noItems") }}
          </v-col>
        </v-row>
      </v-col>

      <v-col cols="12" v-if="datas && datas.length">
        <Pagination :length="totalPages" @onPageSelect="onPagination" />
      </v-col>
    </v-row>
  </div>
</template>
<script>
import ReportsFilters from "./ReportsFilters.vue";
import ReportsSubFilters from "./ReportsSubFilters.vue";
import RegistrationReportCard from "./RegistrationReportCard.vue";
import Pagination from "../../core-module/components/Pagination.vue";
import { excelExport } from "../methods/excelExport";

import VueHtml2pdf from "vue-html2pdf";

export default {
  data() {
    return {
      loading: true,
      datas: [],
      variables: {
        limit: 10,
        skip: 0,
      },
      exporting: false,
      exportAsXl: false,
      totalCount: null,
      organization: null,
      training: null,
      trainer: null,
      employee: null,
      datesRange: {
        startDate: null,
        endDate: null,
      },
      search: null,
      disableSubFilters: true,
      debounceSearch: null,
      totalPages: 0,
    };
  },
  components: {
    ReportsFilters,
    ReportsSubFilters,
    RegistrationReportCard,
    Pagination,
    // VueHtml2pdf,
  },
  apollo: {
    getTrainingRegistrations() {
      return {
        query: require("../../course-module/api/query/getTrainingRegistrations.gql"),
        variables: this.variablesDefaultValue(),
        result({ data, loading }) {
          if (
            data &&
            data.getTrainingRegistrations &&
            data.getTrainingRegistrations.trainingRegistrations
          ) {
            this.datas = data.getTrainingRegistrations.trainingRegistrations;
            this.totalCount = data.getTrainingRegistrations.totalCount;
            let pagesVal = this.totalCount / this.variablesDefaultValue().limit;
            this.totalPages = this.checkNumberIsFloat(pagesVal)
              ? Math.ceil(pagesVal)
              : pagesVal;
            if (this.datas.length) this.disableSubFilters = false;
            else this.disableSubFilters = true;
          }

          this.loading = loading;
        },
      };
    },
  },
  methods: {
    checkNumberIsFloat(value) {
      return Number(value) === value && value % 1 !== 0;
    },
    onPagination(val) {
      if (val > 0) {
        this.variables.skip = this.variables.limit * (val - 1);
        this.refetch();
      }
    },
    onProgress(event) {
      if (event === 100) {
        this.exporting = false;
      }
    },
    variablesDefaultValue() {
      return {
        limit: 10,
        skip: 0,
      };
    },
    exportToPdf() {
      this.exporting = true;
      this.$refs.html2Pdf.generatePdf();
    },
    filterBy(key, value) {
      if (key === "organization") {
        this.organization = value;
        this.variables = this.variablesDefaultValue();
        this.refetch();
      }
      if (key === "search") {
        clearTimeout(this.debounceSearch);
        this.debounceSearch = setTimeout(() => {
          this.apiSearch(value);
        }, 500);
      }

      if (key === "training") {
        this.training = value;
        this.variables = this.variablesDefaultValue();
        this.refetch();
      }

      if (key === "trainer") {
        this.trainer = value;
        this.variables = this.variablesDefaultValue();
        this.refetch();
      }

      if (key === "employee") {
        this.employee = value;
        this.variables = this.variablesDefaultValue();
        this.refetch();
      }
      if (key === "dates") {
        this.datesRange.startDate = value.startDate;
        this.datesRange.endDate = value.endDate;
        this.variables = this.variablesDefaultValue();
        this.refetch();
      }
    },

    apiSearch(val) {
      const searchText = val?.trim() ?? "";

      if (searchText.length > 0) {
        this.search = searchText;
        this.variables = this.variablesDefaultValue();
        this.refetch();
      } else if (searchText.length === 0 && this.search != null) {
        this.search = null;
        this.variables = this.variablesDefaultValue();
        this.refetch();
      }
    },

    async exportToXL() {
      this.exporting = true;
      let exportArr = await this.$apollo
        .query({
          query: require("../../course-module/api/query/getTrainingRegistrations.gql"),
          variables: {
            limit: 0, //1000,//export limit
            skip: 0,
            filterInput: {
              search: this.search ? this.search : null,
              training: this.training ? this.training : null,
              organization: this.organization ? this.organization : null,
              employee: this.employee ? this.employee : null,
              dateFrom: this.datesRange.startDate
                ? this.datesRange.startDate
                : null,
              dateTo: this.datesRange.endDate ? this.datesRange.endDate : null,
            },
          },
        })
        .then(result => {
          this.exporting = false;
          if (result?.data?.getTrainingRegistrations?.trainingRegistrations) {
            let trainingRegistrationsData =
              result.data.getTrainingRegistrations.trainingRegistrations.map(
                trainingRegistration => {
                  let obj = {};
                  obj[this.$t("user.registration.name")] = trainingRegistration
                    ?.employee?.user?.firstName
                    ? `${trainingRegistration.employee.user.firstName || ""} ${
                        trainingRegistration.employee.user.lastName || ""
                      }`
                    : " - ";

                  obj[this.$t("batch.batchNumber")] =
                    trainingRegistration?.batchNumber ?? "-";

                  obj[this.$t("user.registration.training")] =
                    trainingRegistration?.training?.title.length
                      ? this.getLocalisedValue(
                          trainingRegistration?.training?.title
                        )
                      : " - ";
                  obj[this.$t("course.trainer")] = trainingRegistration?.trainer
                    ?.user?.firstName
                    ? `${trainingRegistration.trainer.user.firstName || ""} ${
                        trainingRegistration.trainer.user.lastName || ""
                      }`
                    : " - ";

                  obj[this.$t("user.registration.organization")] =
                    trainingRegistration?.organization?.name.length
                      ? this.getLocalisedValue(
                          trainingRegistration?.organization?.name
                        )
                      : " - ";
                  obj[this.$t("user.department")] =
                    trainingRegistration?.employee?.department ?? " - ";
                  obj[this.$t("user.designation")] =
                    trainingRegistration?.employee?.designation ?? " - ";
                  obj[this.$t("user.registration.registrationStatus")] =
                    trainingRegistration?.status;
                  obj[this.$t("user.registration.employeeId")] =
                    trainingRegistration?.employee?.user
                      ? trainingRegistration?.employee?.user.civilIdOrPassport
                      : " - ";
                  obj[this.$t("user.registration.startDate")] =
                    trainingRegistration?.startDate
                      ? this.$moment(
                          parseInt(trainingRegistration.startDate)
                        ).format("DD MMM YYYY")
                      : " - ";

                  obj[this.$t("reports.certificateExpiryDate")] =
                    this.generateCertificateExpiryDate(trainingRegistration);

                  obj[this.$t("user.certificatesAndProfileCard.type")] =
                    this.capitalizeFirstLetter(
                      trainingRegistration?.trainingMode?.toLowerCase()
                    );

                  return obj;
                }
              );
            return trainingRegistrationsData;
          }
        });
      let name = "registration-reports";
      let fileName = name.concat("-", this.$moment().unix());
      excelExport(exportArr, fileName);
    },
    async refetch() {
      await this.$apollo.queries.getTrainingRegistrations.refetch({
        limit: this.variables.limit,
        skip: this.variables.skip,
        filterInput: {
          search: this.search ? this.search : null,
          training: this.training ? this.training : null,
          trainer: this.trainer ? this.trainer : null,
          organization: this.organization ? this.organization : null,
          employee: this.employee ? this.employee : null,
          dateFrom: this.datesRange.startDate
            ? this.datesRange.startDate
            : null,
          dateTo: this.datesRange.endDate ? this.datesRange.endDate : null,
          // status: this.registrationStatusFilter
          //   ? this.registrationStatusFilter
          //   : null,
        },
      });
    },
  },
};
</script>
